module.exports = __webpack_public_path__ + "img/832-af9553.png";